import { OperationService } from "@/services";
const CanceledOrderCard = () =>
  import("@/components/OrderProcessPage/Withdrawal/CanceledOrderCard/index");
const Captcha = () =>
  import(/* webpackChunkName: "Captcha" */ "@/components/Captcha/index");
import vueAwesomeCountdown from "vue-awesome-countdown";
import { mapGetters } from "vuex";
import * as types from "@/store/types";
import $thousandMask from "@/mixins/thousandMask";
import initService from "@/services/modules/initService";

export default {
  name: "exchange",
  components: { CanceledOrderCard, Captcha, vueAwesomeCountdown },
  props: [],
  mixins: [$thousandMask],
  data() {
    return {
      e1: 2,
      isCounterExpired: false,
      modalStatus: "canceledOrder",
      dialog: false,
      counterTime: 0,
      interval: {},
      value: 100,
      time: 0,
      orderData: {},
      loading: false,
      iso: "",
      createOrderData: {},
      loadingGetToken: false,
      loadingCreateOrder: false,
      isSourceAmountFix: "",
      copyFlag: true,
      captcha_token: null,
      captcha_value: null,
      captcha_hash: null,
      reloadCaptcha: false,
      publicUrl: process.env.VUE_APP_PUBLIC_BASE_URL,
      captchaStatus: false
    };
  },
  computed: {
    ...mapGetters({
      getOrderStep: types.operations.getters.GET_ORDER_STEP
    }),
    exchangeOrderStep() {
      if (Object.entries(this.getOrderStep).length !== 0) {
        return this.getOrderStep.convert;
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  mounted() {
    if (this.$route.query.ref_no) {
      this.getCreateOrderData();
    } else {
      this.getOrderData();
    }
    this.resetTime();
    this.getCaptchaStatus();
  },
  methods: {
    captchaChanged(captchaData) {
      this.captcha_token = captchaData.token;
      this.captcha_value = captchaData.value;
    },
    getCaptchaStatus() {
      initService.initSecurity().then(res => {
        this.captchaStatus = res.data.data.captcha.orders_exchange;
      });
    },
    resetTime() {
      this.interval = setInterval(() => {
        if (this.value === 0) {
          return (this.value = 0);
        }
        this.time += 1;
        this.value = parseInt(100 - (100000 * this.time) / this.counterTime);
      }, 1000);
    },
    cancelOrder() {
      this.$router.go(-1);
    },
    // onCancelOrder(event) {
    //   this.dialog = event;
    //   this.$router.push(
    //     `/panel/operations/exchange?from=${this.orderData.from_currency.iso}`
    //   );
    // },
    getOrderData() {
      this.loadingGetToken = true;
      OperationService.getOrderTokenData(this.$route.params.token)
        .then(response => {
          this.isSourceAmountFix =
            response.data.data.order_data.is_source_amount_fix;
          this.counterTime = parseInt(response.data.data.expires_in);
          this.orderData = response.data.data.order_data;
        })
        .catch(error => {
          this.$toast.error(error.data.message);
          this.$router.push({
            path: `/operations/exchange?from=BTC`
          });
        })
        .finally(() => {
          this.loadingGetToken = false;
        });
    },
    getCreateOrderData() {
      this.loadingCreateOrder = true;
      OperationService.showOrder(this.$route.query.ref_no)
        .then(response => {
          this.createOrderData = response.data.data;
          this.e1 = 3;
        })
        .catch(error => {
          this.$toast.error(error.data.message);
        })
        .finally(() => {
          this.loadingCreateOrder = false;
        });
    },
    buyCurrency() {
      this.loading = true;
      this.loadingGetToken = true;
      let data = {
        from_currency_id: this.orderData.from_currency.id,
        from_amount: this.orderData.gross_from_amount,
        to_currency_id: this.orderData.to_currency.id,
        to_amount: this.orderData.gross_to_amount,
        is_source_amount_fix: this.isSourceAmountFix,
        captcha_token: this.captcha_token,
        captcha_value: this.captcha_value
      };
      OperationService.exchangeGetToken(data)
        .then(response => {
          this.$router.push({
            path: `/submit-order/${response.data.data.token}/exchange`
          });
          this.$refs.unregisterTimer.startCountdown(true);
          this.value = 100;
          this.time = 0;
          clearInterval(this.interval);
          this.getOrderData();
          this.resetTime();
        })
        .catch(error => {
          this.captcha_token = null;
          this.captcha_value = null;
          this.captcha_hash = error.data.captcha_hash;
        })
        .finally(() => {
          this.loading = false;
          this.loadingGetToken = false;
          this.reloadCaptcha = !this.reloadCaptcha;
        });
    },
    showFactor() {
      this.loading = true;
      this.loadingCreateOrder = true;
      let data = {
        order_token: this.$route.params.token,
        from_amount: this.orderData.from_amount,
        to_amount: this.orderData.to_amount,
        is_from_balance: true,
        is_to_balance: true,
        is_fee_from_source: false
      };
      OperationService.storeOrder(data)
        .then(response => {
          this.$router.push({
            path: `/submit-order/${data.order_token}/exchange?ref_no=${response.data.data.ref_no}`
          });
          this.createOrderData = response.data.data;
          this.e1 = 3;
        })
        .catch(error => {
          this.$toast.error(error.data.message);
        })
        .finally(() => {
          this.loading = false;
          this.loadingCreateOrder = false;
        });
    },
    createOrderRef() {
      if (this.copyFlag) {
        this.copyFlag = false;
        this.$toast.success(this.$t("orderProcessPage.txNumberCopied"));
      } else {
        setTimeout(() => {
          this.copyFlag = true;
        }, 3000);
      }
    }
  }
};
